import React from 'react';
import renderIf from 'render-if';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Createtabs from 'components/Createtabs';
import SearchUser from 'components/SearchUser';
// import SearchUserByName from 'components/SearchUserByName';
import Button from 'components/CustomButton/CustomButton';

import UserInfo from '../Userinfo';
import UpgradeStudent from './components/UpgradeStudent';
import OverrideDivision from './components/OverrideStudent';
import StudentExplorer from './components/StudentExplorer';
import StudentEvaluation from './components/StudentEvaluation/View';
import ResetDashboard from './components/ResetDashboard';

import styles from './style.scss';
import Error from '../../../../components/ErrorMessage/Error';


const tabs = ['Select User', 'Upgrade Student', 'Override Student', 'Student Evaluation', 'Login As User', 'Dashboard Reset', 'Student Explorer'];
const StudentView = (props) => {
  const { setTabToInitial, userInfo, redirectUser, upgradeStudent, getStudentForStudentExplorer,
    evaluateStudent, overrideStudent, upgradeInfo, overrideInfo, evaluatedInfo, esError,
    filterBasedStudents, isLoading, dashboardReset, resetStudentDashboard, searchEsUserData,
    SearchAtheleteByName, searchEsUserRequested,
    isEsLoading } = props;
  const selectUser = renderIf(props.tab === 0);
  const renderUpgradeStudent = renderIf(props.tab === 1);
  const renderOverrideStudent = renderIf(props.tab === 2);
  const studentEvaluation = renderIf(props.tab === 3);
  const loginAsStudent = renderIf(props.tab === 4);
  const resetDashboard = renderIf(props.tab === 5);
  const studentExplorer = renderIf(props.tab === 6);
  const renderLoginButton = renderIf(userInfo.name !== undefined);
  const renderErrorMessage = renderIf(userInfo.name === undefined);
  return (
    <div className={cn('col s12')}>
      <Createtabs
        tabs={tabs}
        index={props.tab}
        activeClass={styles.activeClass}
        container={styles.container}
        tabListener={props.tabListener}
      />
      <div className={cn('col s12', styles.tabViews)}>
        {selectUser(<SearchUser {...props} userType="STUDENT" />)}
        {renderUpgradeStudent(
          <UpgradeStudent
            userInfo={userInfo}
            setTabToInitial={setTabToInitial}
            upgradeStudent={upgradeStudent}
            upgradeInfo={upgradeInfo}
          />)}
        {renderOverrideStudent(
          <OverrideDivision
            userInfo={userInfo}
            setTabToInitial={setTabToInitial}
            overrideStudent={overrideStudent}
            overrideInfo={overrideInfo}
          />)}
        {studentEvaluation(
          <StudentEvaluation
            userInfo={userInfo}
            setTabToInitial={setTabToInitial}
            evaluateStudent={evaluateStudent}
            evaluatedInfo={evaluatedInfo}
          />)}
        {studentExplorer(
          <StudentExplorer
            getStudentForStudentExplorer={getStudentForStudentExplorer}
            // SearchUserByFullName={SearchUserByFullName}
            SearchAtheleteByName={SearchAtheleteByName}
            searchEsUserRequested={searchEsUserRequested}
            esError={esError}
            // redirectAthelete={redirectAthelete}
            searchEsUserData={searchEsUserData}
            filterBasedStudents={filterBasedStudents}
            // filterBasedEsStudents={filterBasedEsStudents}
            loading={isLoading}
            IsLoading={isEsLoading}
          />,
        )}
        {loginAsStudent(
          <div className={cn('col s12', styles.loginContainer)}>
            {renderLoginButton(
              <div className={cn('col s12', styles.removePadding)}>
                <UserInfo userInfo={userInfo} userType="STUDENT" />
                <Button onClick={redirectUser} style={styles.buttonContainer} label="LOGIN AS ABOVE USER" />
              </div>,
          )}
            {renderErrorMessage(
              <div>
                <Error message="Please select user in first tab" />
                <Button onClick={setTabToInitial} style={styles.dummyContainer} label="SELECT USER" />
              </div>,
          )}
          </div>,
      )}
        {resetDashboard(
          <ResetDashboard
            userInfo={userInfo}
            setTabToInitial={setTabToInitial}
            dashboardReset={dashboardReset}
            resetStudentDashboard={resetStudentDashboard}
          />,
        )}
      </div>
    </div>
  );
};

StudentView.propTypes = {
  tabListener: PropTypes.func.isRequired,
  tab: PropTypes.number.isRequired,
  userInfo: PropTypes.shape.isRequired,
  setTabToInitial: PropTypes.func.isRequired,
  redirectUser: PropTypes.func.isRequired,
  // redirectAthelete: PropTypes.func.isRequired,
  upgradeStudent: PropTypes.func.isRequired,
  overrideStudent: PropTypes.func.isRequired,
  evaluateStudent: PropTypes.func.isRequired,
  getStudentForStudentExplorer: PropTypes.func.isRequired,
  // SearchUserByFullName: PropTypes.func.isRequired,
  SearchAtheleteByName: PropTypes.func.isRequired,
  searchEsUserRequested: PropTypes.bool.isRequired,
  esError: PropTypes.bool.isRequired,
  searchEsUserData: PropTypes.shape.isRequired,
  upgradeInfo: PropTypes.bool.isRequired,
  overrideInfo: PropTypes.bool.isRequired,
  evaluatedInfo: PropTypes.bool.isRequired,
  filterBasedStudents: PropTypes.shape.isRequired,
  // filterBasedEsStudents: PropTypes.shape.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isEsLoading: PropTypes.bool.isRequired,
  dashboardReset: PropTypes.bool.isRequired,
  resetStudentDashboard: PropTypes.func.isRequired,
};

export default StudentView;



// WEBPACK FOOTER //
// ./src/containers/Admin/components/StudentView/View.js